import { MappingClientT, PoiContainerCollectionItemT } from 'bovaljaren-models';
import React, { ReactElement, useMemo, useState } from 'react';
import PoiInfo from '../../PoiInfo/PoiInfo';
import { calculateStyle, calculateTipForegroundStyle, calculateTipStyle, getPolygonMeasurements, measureImage, PolygonMeasurementsT } from '../mapping.helper';
import './PoiMappingBox.scss';

type PoiMappingBoxProps={
    previewPoi: PoiContainerCollectionItemT;
    poiMapping?: MappingClientT;
};


const PoiMappingBox: React.FC<PoiMappingBoxProps> = ({ previewPoi, poiMapping }): ReactElement => {
    const [imageDimensions] = useState(measureImage());

    const polygonMeasurements = useMemo((): PolygonMeasurementsT => {
        return getPolygonMeasurements(poiMapping);
    }, [poiMapping]);

    return (
        <div style={calculateStyle(polygonMeasurements, imageDimensions, poiMapping, 2)} className={'bv-mapping-facts-label bv-mapping-facts-label--poi'}>
            <div className="bv-poi-label-content bv-poi-label-content--poi">
                <PoiInfo previewPoi={previewPoi}/>
            </div>
        </div>
    );
};


export default PoiMappingBox;